import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { getTourDefinition, tourIdForPathname } from "@/lib/tours/registry";
import { startTour } from "@/lib/tours/startTour";
import { hasSeenTour } from "@/lib/tours/tourStorage";

const AUTO_START_DELAY_MS = 800;

/** Startet beim ersten Besuch automatisch die passende Seiten-Tour. */
export function TourAutoStart() {
  const { pathname } = useLocation();
  const startedRef = useRef<string | null>(null);

  useEffect(() => {
    const tourId = tourIdForPathname(pathname);
    if (!tourId) return;

    const definition = getTourDefinition(tourId);
    if (!definition.autoStart) return;
    if (hasSeenTour(tourId)) return;

    const shellNeeded = tourId === "dashboard" && !hasSeenTour("shell");
    const sessionKey = shellNeeded ? `${tourId}+shell` : tourId;
    if (startedRef.current === sessionKey) return;

    const timer = window.setTimeout(() => {
      const started = startTour(tourId, { includeShell: shellNeeded });
      if (started) startedRef.current = sessionKey;
    }, AUTO_START_DELAY_MS);

    return () => window.clearTimeout(timer);
  }, [pathname]);

  return null;
}
